import React, {Component} from 'react';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Configuration from "./config";

am4core.useTheme(am4themes_animated);


class XYCharts extends Component {
  constructor (props){
    super(props);
    this.state = {
      chart: false,
      id_div: this.props.id_div,
      data: this.props.data,
      config: this.props.config,
      width: this.props.width,
      height: this.props.height
    }
    this.updateChart = this.updateChart.bind(this);
  }
  async componentDidMount () {
    let chart = am4core.create(this.state.id_div, am4charts.XYChart);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    let configChart = new Configuration(chart, this.state.data, this.state.config);
    configChart[this.props.config.orientation+'_'+this.props.config.type]();
    await this.setState({
      chart: chart
    })
  }
  componentWillUnmount() {
    if (this.state.chart) {
      this.state.chart.dispose();
    }
  }
  updateChart = async () => {
    await this.setState({
      data: this.props.data,
      config: this.props.config,
      width: this.props.width,
      height: this.props.height
    })
    let chart = am4core.create(this.state.id_div, am4charts.XYChart);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    let configChart = new Configuration(chart, this.state.data, this.state.config);
    configChart[this.state.config.orientation+'_'+this.state.config.type]();
    await this.setState({
      chart: chart
    })
  }
  render () {
    if((JSON.stringify(this.props.data) !== JSON.stringify(this.state.data)) || (JSON.stringify(this.props.config) !== JSON.stringify(this.state.config)) || (this.props.width !== this.state.width) || (this.props.height !== this.state.height)){
      this.updateChart();
    }
    return(
      <div id={ this.state.id_div } style={{ width: this.state.width, height: this.state.height }}></div>
    );
  }
}


export default XYCharts